class Cart {
  get() {
    return fetch("/cart.js", {
      method: "GET",
    })
      .then((response) => response.json())
      .then((cart) => cart);
  }

  generateShopifyCartUpdateBody({ id, quantity }) {
    const params = new URLSearchParams();
    params.append(`updates[${id}]`, String(quantity));
    return params.toString();
  }

  update(data) {
    return fetch("/cart/update.js", {
      method: "POST",
      body: this.generateShopifyCartUpdateBody(data),
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
    })
      .then((response) => {
        return response.json().then((cart) => {
          if (!response.ok) {
            cart["errors"] = [cart.description];
          }
          return cart;
        });
      })
      .catch(() => {
        return {
          errors: ["An error occurred while updating the cart"],
        };
      });
  }

  generateShopifyCartAddBody({ id, quantity }) {
    return `quantity=${quantity}&id=${id}`;
  }

  /**
   * Adds a product to the Shopify cart
   *
   * @param {Object} data {id: <id>, quantity: <Number>}
   */
  add(data) {
    return fetch("/cart/add.js", {
      method: "POST",
      body: this.generateShopifyCartAddBody(data),
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
    }).then((response) => response.json());
  }
}

export default new Cart();
